import React from "react";

function SvgEntertainment({
  color = "currentColor",
  width = 22,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      {...props}
    >
      <path
        d="M7.05 12C5.38333 12 3.95833 11.4167 2.775 10.25C1.59167 9.08333 1 7.66667 1 6C1 4.33333 1.59167 2.91667 2.775 1.75C3.95833 0.583333 5.39167 0 7.075 0H7.475C7.10833 0.416667 6.825 0.883333 6.625 1.4C6.425 1.91667 6.325 2.45 6.325 3C6.325 4.25 6.7625 5.3125 7.6375 6.1875C8.5125 7.0625 9.575 7.5 10.825 7.5C11.2083 7.5 11.5833 7.45417 11.95 7.3625C12.3167 7.27083 12.6667 7.13333 13 6.95C12.7667 8.41667 12.0917 9.625 10.975 10.575C9.85833 11.525 8.55 12 7.05 12ZM7.025 10C7.425 10 7.82083 9.94583 8.2125 9.8375C8.60417 9.72917 8.96667 9.55833 9.3 9.325C7.85 8.975 6.66667 8.22083 5.75 7.0625C4.83333 5.90417 4.35833 4.58333 4.325 3.1C3.89167 3.48333 3.5625 3.925 3.3375 4.425C3.1125 4.925 3 5.45 3 6C3 7.1 3.39167 8.04167 4.175 8.825C4.95833 9.60833 5.90833 10 7.025 10ZM17 9H19V6H17V9ZM18 13C18.2833 13 18.5208 12.9042 18.7125 12.7125C18.9042 12.5208 19 12.2833 19 12V11H17V12C17 12.2833 17.0958 12.5208 17.2875 12.7125C17.4792 12.9042 17.7167 13 18 13ZM4.85 18H9.15C9.38333 18 9.59167 17.9333 9.775 17.8C9.95833 17.6667 10.075 17.4833 10.125 17.25L10.45 16H3.55L3.875 17.25C3.925 17.4833 4.04167 17.6667 4.225 17.8C4.40833 17.9333 4.61667 18 4.85 18ZM0 20V18H2C1.98333 17.95 1.97083 17.9042 1.9625 17.8625C1.95417 17.8208 1.94167 17.775 1.925 17.725L1 14H13L12.075 17.725C12.0583 17.775 12.0458 17.8208 12.0375 17.8625C12.0292 17.9042 12.0167 17.95 12 18H17V14.825C16.4 14.6083 15.9167 14.2417 15.55 13.725C15.1833 13.2083 15 12.6333 15 12V4H21V12C21 12.6333 20.8167 13.2083 20.45 13.725C20.0833 14.2417 19.6 14.6083 19 14.825V18H22V20H0Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgEntertainment;
